import { render, staticRenderFns } from "./DictionariesList.vue?vue&type=template&id=d84b66dc&"
import script from "./DictionariesList.vue?vue&type=script&lang=js&"
export * from "./DictionariesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports